import { render, staticRenderFns } from "./EditCustomization.vue?vue&type=template&id=6925ca4c&scoped=true&"
import script from "./EditCustomization.vue?vue&type=script&lang=js&"
export * from "./EditCustomization.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomization.vue?vue&type=style&index=0&id=6925ca4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6925ca4c",
  null
  
)

export default component.exports